import React from 'react';
import { AlertTriangleIcon, SkullIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 bg-dark-950 relative border-y border-cyan-900/30" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-128">
        <div className="text-center mb-10" data-id="element-129">
          <SkullIcon className="w-12 h-12 text-red-500 mx-auto mb-4 opacity-80" data-id="element-130" />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-131">
            The era of "Prompt Engineering" is{' '}
            <span className="text-red-500" data-id="element-132">DEAD</span>.
          </h2>
          <p className="text-xl text-gray-400" data-id="element-133">
            Stop selling AI writing like a cheap commodity and start owning the
            technical architecture of 2026.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-134">
          <div className="bg-dark-900 border border-red-900/30 p-8 rounded-lg relative overflow-hidden group" data-id="element-135">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500" data-id="element-136"></div>
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-137">
              <span className="text-red-500 line-through" data-id="element-138">The Commodity</span>
            </h3>
            <ul className="space-y-4 text-gray-400" data-id="element-139">
              <li className="flex items-start gap-3" data-id="element-140">
                <span className="text-red-500 mt-1" data-id="element-141">✕</span>
                Manually "prompting" blog posts
              </li>
              <li className="flex items-start gap-3" data-id="element-142">
                <span className="text-red-500 mt-1" data-id="element-143">✕</span>
                Copying-and-pasting into Google Docs
              </li>
              <li className="flex items-start gap-3" data-id="element-144">
                <span className="text-red-500 mt-1" data-id="element-145">✕</span>
                Chasing clients for $50 an article
              </li>
              <li className="flex items-start gap-3" data-id="element-146">
                <span className="text-red-500 mt-1" data-id="element-147">✕</span>
                Competing against millions willing to work for $5/hour
              </li>
            </ul>
          </div>

          <div className="bg-dark-900 border border-cyan-500/30 p-8 rounded-lg relative overflow-hidden box-glow" data-id="element-148">
            <div className="absolute top-0 left-0 w-1 h-full bg-cyan-400" data-id="element-149"></div>
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-150">
              <span className="text-cyan-400" data-id="element-151">The Architect</span>
            </h3>
            <ul className="space-y-4 text-gray-300" data-id="element-152">
              <li className="flex items-start gap-3" data-id="element-153">
                <span className="text-cyan-400 mt-1" data-id="element-154">✓</span>
                Treating AI as Infrastructure, not a toy
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <span className="text-cyan-400 mt-1" data-id="element-156">✓</span>
                Building a system designed to scale without you
              </li>
              <li className="flex items-start gap-3" data-id="element-157">
                <span className="text-cyan-400 mt-1" data-id="element-158">✓</span>
                Selling OUTCOMES, not prompts
              </li>
              <li className="flex items-start gap-3" data-id="element-159">
                <span className="text-cyan-400 mt-1" data-id="element-160">✓</span>
                Automating lead gen, creation, and distribution
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}